import { FC } from 'react'
import styles from './Compare.module.scss'
import { CompareItemProps, CompareProps } from './Compare.types'
import { Img } from 'components/basic/Img'
import { EightLogo } from 'components/EightLogo'

export const Compare: FC<CompareProps> = (props) => {
	const { items = getDefaultItems() } = props
	return (
		<section className={styles.container}>
			<header>
				<small>Compare</small>
				<h2>Nothing compares to the Pod</h2>
				<p>Crafted with precision, the Pod delivers an all-in-one sleep system that is unmatched. Don't settle. Elevate your sleep.</p>
			</header>
			<Img
				src={'https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/pod-compare/compare-lifestyle.jpg'}
				alt={'A couple lying on the Pod, smiling.'}
				objectFit={'cover'}
				className={styles.image}
			/>
			<CompareTable items={items} />
		</section>
	)
}

const getDefaultItems = (): CompareItemProps[] => [
	{
		name: 'Automatic temperature',
	},
	{
		name: 'Personalized cooling',
	},
	{
		name: 'Seamless comfort',
	},
	{
		name: 'Dual-zone control',
	},
	{
		name: 'Clinically-validated',
	},
	{
		name: 'Fits on any mattress',
	},
	{
		name: 'Sleep and health tracking',
	},
	{
		name: 'Backed by sleep experts',
	},
]

const CompareTable = ({ items }: { items: CompareItemProps[] }) => {
	return (
		<table className={styles.table}>
			<thead>
				<tr>
					<th className={'vh'}>Features</th>
					<th>
						<span className={'vh'}>Eight Sleep</span>
						<div className={styles.eight_logo_container}>
							<EightLogo className={styles.eight_logo} />
						</div>
					</th>
					<th>
						<p className={styles.others_container}>Others</p>
					</th>
				</tr>
			</thead>
			<tbody>
				{items.map((item) => {
					const { name, eight = true, others = false } = item
					return (
						<tr
							key={`item-${name}`}
							className={styles.table_row}
						>
							<td>
								<p className={styles.table_row_name}>{name}</p>
							</td>
							<td>
								<div>
									<Check checked={eight} />
								</div>
							</td>
							<td>
								<div>
									<Check checked={others} />
								</div>
							</td>
						</tr>
					)
				})}
			</tbody>
		</table>
	)
}

const Check = ({ checked }: { checked: boolean }) => {
	if (checked)
		return (
			<>
				<span className={'vh'}>Yes</span>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 22 22"
					fill="none"
					className={styles.checkmark}
				>
					<g clip-path="url(#clip0_2310_6848)">
						<ellipse
							cx="10.9216"
							cy="11.0798"
							rx="10.24"
							ry="10.24"
							fill="#1862FF"
						/>
						<path
							d="M9.31966 12.6796L7.278 10.6379C7.21496 10.5749 7.14013 10.5249 7.05777 10.4908C6.9754 10.4567 6.88713 10.4391 6.79798 10.4391C6.70884 10.4391 6.62056 10.4567 6.5382 10.4908C6.45584 10.5249 6.38101 10.5749 6.31797 10.6379C6.25493 10.701 6.20493 10.7758 6.17081 10.8582C6.1367 10.9405 6.11914 11.0288 6.11914 11.1179C6.11914 11.2071 6.1367 11.2954 6.17081 11.3777C6.20493 11.4601 6.25493 11.5349 6.31797 11.598L9.63967 14.9197L14.9217 8.39466C15.0241 8.26858 15.0798 8.11114 15.0798 7.94857V7.90121C15.0798 7.76686 15.0388 7.6357 14.9624 7.52519C14.886 7.41468 14.7778 7.33003 14.6521 7.28252C14.5264 7.235 14.3893 7.22686 14.2589 7.25918C14.1285 7.29149 14.011 7.36274 13.922 7.46344L9.31966 12.6796Z"
							fill="white"
						/>
					</g>
					<defs>
						<clipPath id="clip0_2310_6848">
							<rect
								width="20.48"
								height="20.4799"
								fill="white"
								transform="translate(0.681641 0.839844)"
							/>
						</clipPath>
					</defs>
				</svg>
			</>
		)

	return (
		<>
			<span className={'vh'}>No</span>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 21 22"
				fill="none"
				className={styles.xmark}
			>
				<g clip-path="url(#clip0_2310_6881)">
					<path
						d="M20.0411 11.0798C20.0411 16.3817 15.7431 20.6798 10.4412 20.6798C5.13923 20.6798 0.841172 16.3817 0.841172 11.0798C0.841172 5.7779 5.13923 1.47984 10.4412 1.47984C15.7431 1.47984 20.0411 5.7779 20.0411 11.0798Z"
						stroke="black"
						strokeWidth="1.28"
					/>
					<path
						d="M8.20289 8.83959L10.4429 11.0796M10.4429 11.0796L12.6829 13.3196M10.4429 11.0796L12.6829 8.83959M10.4429 11.0796L8.20289 13.3196"
						stroke="black"
						strokeWidth="1.31663"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</g>
				<defs>
					<clipPath id="clip0_2310_6881">
						<rect
							width="20.48"
							height="20.4799"
							fill="white"
							transform="translate(0.201172 0.839844)"
						/>
					</clipPath>
				</defs>
			</svg>
		</>
	)
}
